'use client';

import Image from '@/components/Image';
import { cn } from '@/utils/tailwind-merge';
import Marquee from 'react-fast-marquee';

export interface RunningLineItem {
    type: 'text' | 'image';
    content: string;
    className?: string;
}

interface RunningLineProps {
    displayItems: RunningLineItem[];
    separator?: string;
    className?: string;
    speed?: number;
    pauseOnHover?: boolean;
    gradient?: boolean;
    autoFill?: boolean;
}

const RunningLine = (props: RunningLineProps) => {
    const {
        separator = '',
        displayItems,
        className,
        speed = 70,
        pauseOnHover = false,
        gradient = false,
        autoFill = false,
    } = props;
    return (
        <Marquee
            className={cn('', className)}
            speed={speed}
            pauseOnHover={pauseOnHover}
            gradient={gradient}
            autoFill={autoFill && displayItems.length > 0}
        >
            {displayItems.map((item, index) => (
                <div key={index} className="flex items-center gap-[50px] mr-[50px]">
                    {item.type === 'text' && <span className={item.className}>{item.content}</span>}
                    {item.type === 'image' && <Image src={item.content} alt={item.content} fill />}
                    <span className="text-white uppercase">{separator}</span>
                </div>
            ))}
        </Marquee>
    );
};

export default RunningLine;
